import { render, staticRenderFns } from "./MyParametricTable.vue?vue&type=template&id=5305febc&"
import script from "./MyParametricTable.vue?vue&type=script&lang=js&"
export * from "./MyParametricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports